import { render, staticRenderFns } from "./ElementPreview.vue?vue&type=template&id=1f76a8fe&scoped=true&"
import script from "./ElementPreview.vue?vue&type=script&lang=js&"
export * from "./ElementPreview.vue?vue&type=script&lang=js&"
import style0 from "./ElementPreview.vue?vue&type=style&index=0&id=1f76a8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76a8fe",
  null
  
)

export default component.exports